import { ReactNode, useState, createContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { snackEmoji } from '../helpers/emoji'

import { CustomerData } from '../interfaces/CustomerData'
import { SnackData } from '../interfaces/SnackData'

interface Snack extends SnackData {
  quantity: number
  subtotal: number
}

interface CartContextProps {
  cart: Snack[]
  addSnackCart: (snack: SnackData) => void
  removeSnackCart: (snack: Snack) => void
  snackCartIncrement: (sanck: Snack) => void
  snackCartDecrement: (sanck: Snack) => void
  confirmOrder: () => void
  payOrder: (customer: CustomerData) => void
}

interface CartProviderProps {
  children: ReactNode
}

export const CartContext = createContext({} as CartContextProps)

const localStorageKey = '@foodCommerce:cart'

export function CartProvider({ children }: CartProviderProps) {
  const navigate = useNavigate()
  const [cart, setCart] = useState<Snack[]>(() => {
    const value = localStorage.getItem(localStorageKey)
    if (value) return JSON.parse(value)

    return []
  })

  const saveCart = (items: Snack[]) => {
    setCart(items)
    localStorage.setItem(localStorageKey, JSON.stringify(items))
  }

  const removeSnackCart = (snack: Snack) => {
    const newCart = cart.filter((item) => !(item.id === snack.id && item.snack === snack.snack))
    saveCart(newCart)
  }

  const updateSnackQuantity = (snack: Snack, newQuantity: number) => {
    if (newQuantity <= 0) return

    const snackExixtsCart = cart.find((item) => item.id === snack.id && item.snack === snack.snack)

    if (!snackExixtsCart) return

    const newCart = cart.map((item) => {
      if (item.id === snackExixtsCart.id && item.snack === snack.snack) {
        return {
          ...item,
          quantity: newQuantity,
          subtotal: newQuantity * item.price,
        }
      }
      return item
    })

    saveCart(newCart)
  }

  const snackCartIncrement = (snack: Snack) => updateSnackQuantity(snack, snack.quantity + 1)

  const snackCartDecrement = (snack: Snack) => updateSnackQuantity(snack, snack.quantity - 1)

  const addSnackCart = (snack: SnackData): void => {
    const snackExistsCart = cart.find((item) => item.snack === snack.snack && item.id === snack.id)

    if (snackExistsCart) {
      const newCart = cart.map((item: Snack) => {
        if (item.id === snack.id) {
          const quantity = item.quantity + 1
          const subtotal = item.price * quantity
          return { ...item, quantity, subtotal }
        }
        return item
      })
      toast.success(`Outro(a) ${snackEmoji(snack.snack)} ${snack.name} adicionado nos pedidos!`)
      saveCart(newCart)
      return
    }

    const newSnack = { ...snack, quantity: 1, subtotal: snack.price }
    const newCart = [...cart, newSnack]

    toast.success(`${snackEmoji(snack.snack)} ${snack.name} adicionado com sucesso!`)

    saveCart(newCart)
  }

  const confirmOrder = () => navigate('/payment')

  const cleanCart = () => localStorage.removeItem(localStorageKey)

  const payOrder = (customer: CustomerData) => {
    console.log(cart, customer)
    cleanCart()
    // navigate('/payment')
  }

  return (
    <CartContext.Provider
      value={{
        cart,
        addSnackCart,
        snackCartIncrement,
        snackCartDecrement,
        removeSnackCart,
        confirmOrder,
        payOrder,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}
